import React from "react"
import { Link } from "gatsby"
// import Helmet from "react-helmet";
// import { useState } from "react";

const VantageRewardsFr = ({ VRpremium, VRenhance, activeTab, duration }) => {
  return (
    <section className="rewardsContainer">
      {/*<div className="text-center py-20 text-lg font-bold">Pricing Slider</div>*/}

      {/* Designing monthly and yearly tabs */}
      <div className="monthlyYearlyTabContainer">
        <div className="tabContainer">
          <button
            onClick={activeTab}
            id="monthly"
            className="z-10 text-sm text-white font-semibold py-3 px-8 text-white focus:outline-none"
          >
            Pay Monthly
          </button>
          <button
            onClick={activeTab}
            id="yearly"
            className="z-10 py-3 px-8 text-sm text-white font-semibold focus:outline-none"
          >
            Pay Yearly
          </button>
          <div
            className={
              duration === "yearly"
                ? "absolute left-1 bottom-2/6 w-1/2 bg-white rounded-full z-20 h-5/6 activeTab flex justify-center items-center"
                : "flex justify-center items-center absolute left-1 bottom-2/6 w-1/2 bg-white inactiveTab rounded-full z-20 h-5/6"
            }
          >
            <h4 className="capitalize text-sm font-bold">Pay {duration}</h4>
          </div>
        </div>
        <p className="text-sm mt-6 text-gray-900">
          Choose yearly plan and save{" "}
          <span className="text-orange font-semibold">30% off</span>
        </p>
      </div>

      {/*Designing the price cards*/}
      {/*Premium*/}
      <div className="flexJustifyCenter">
        <div className="premiumParent">
          <div className="premiumCard">
            <h2 className="text-sm tracking-widest title-font mb-1 font-medium">
              Premium
            </h2>
            <div className="flex items-center h-auto">
              <h1 className="premiumPriceValue">${VRpremium}</h1>{" "}
              <p className="premiumDuration">&nbsp; / Per month</p>
            </div>
            <p className="premiumRate">$3 per user per month</p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Récompenses automatisées
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Reconnaissance sociale
            </p>
            <p className="text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Nominations de collègues
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Rôles d'administrateur avancés
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              AFlux de travail des récompenses
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Configuration des badges et des récompenses Gestion globale des
              points
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              LLancement du matériel
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Tableau de bord analytique
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Récompenses en points
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Échange de cartes-cadeaux
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Gestion des points globaux
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Chargement en masse via CSV
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Catalogue global
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Rapports personnalisés
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="premiumbulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              Assistance prioritaire
            </p>
            <div className="mt-5 mb-4 sm:mt-8 md:mt-10 flex justify-center">
              <div>
                <Link
                  to="#schedule-demo"
                  className="vc-colored-btn text-sm md:text-base"
                >
                  Schedule a Free Demo
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/*Enhanced*/}
        <div className="p-0 md:p-2 mt-6 md:mt-0 md:w-1/2 w-full">
          <div className="enhancedCard">
            <h2 className="text-sm tracking-widest title-font mb-1 font-medium">
              Enterprize
            </h2>
            <div className="flex items-center h-auto">
              <h1 className="enhancedPriceValue">${VRenhance}</h1>{" "}
              <p className="enhancedDuration">&nbsp; / Per month</p>
            </div>
            <p className="text-purple-10">$7 per user per month</p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="enhancedBulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <p className="text-purple-50 mb-0">
                Comprend tout dans Premium, plus
              </p>
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="enhancedBulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <p className="text-purple-50 mb-0">Annuaire des services</p>
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="enhancedBulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <p className="text-purple-50 mb-0">
                Flux de travail personnalisé
              </p>
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="enhancedBulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <p className="text-purple-50 mb-0">Solution en marque blanche</p>
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="enhancedBulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <p className="text-purple-50 mb-0">
                Intégration de l'authentification unique
              </p>
            </p>
            <p className="flexItemCenter text-gray-500 mb-4">
              <span className="enhancedBulletPoint">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  stroke-linejoin="round"
                  strokewidth="2.5"
                  className="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <p className="text-purple-50 mb-0">
                Gestionnaire de compte dédié
              </p>
            </p>
            <div className="mt-5 sm:mt-8 md:mt-10 flex justify-center">
              <div>
                <Link
                  to="#schedule-demo"
                  className="vc-white-btn text-sm md:text-base"
                >
                  Schedule a Free Demo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VantageRewardsFr
